import type { Truthy } from '@dmp/shared/types';

/**
 * Typeguard boolean value - eliminate any falsy type from Array.filter
 *
 * Usage:
 * glasses.filter(truthy) => Glass[]
 */
export const truthy = <T>(value: T): value is Truthy<T> => !!value;
